import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';
import { of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AdminChatService {

  constructor(private afs: AngularFirestore) { }

  chats = null;
  id: string = "";
  subscription;

  subscribeToChats() {
    if (!this.chats) {
      this.subscription = this.afs.collection('usuariosChat').valueChanges({ idField: 'id' })
        .subscribe(chats => {
          this.chats = chats;
          this.chats.sort((a,b) => +b.timestamp - +a.timestamp)
        });
    }
  }

  getChat(id) {
    return this.afs.collection("usuariosChat").doc(id).snapshotChanges();
  }

  async pushMessage(id, data) {
    const timestamp = new Date();
    const usuario = data.usuario;
    const mensaje = data.mensaje;
    const admin = data.admin;
    const msg = {
      timestamp: timestamp,
      usuario: usuario,
      mensaje: mensaje,
      admin: admin,
      leido: "no leido"
    }
    let newChat = []
    await this.afs.collection("usuariosChat").doc(id).ref.get().then(async doc => {
      if (doc.exists) {
        newChat = doc.data()["chat"].concat(msg);
      } else {
        newChat = newChat.concat(msg);
      }
    })
    this.afs.doc(`usuariosChat/${id}`).set({chat: newChat, timestamp: new Date(),}, {merge: true});
  }

  actualizarStatus(id, status) {
    this.afs.doc(`usuariosChat/${id}`).set({status: status}, {merge: true});
  }

  async leido (id) {
    const doc = await this.afs.doc(`usuariosChat/${id}`).ref.get();
    console.log("entre a leido")
    const chat = doc.data()["chat"];
    for (let index = 0; index < chat.length; index++) {
      if (chat[index].admin == false) {
        chat[index].leido = "leido"
      } 
      console.log(chat)
    }
    await this.afs.doc(`usuariosChat/${id}`).update({
      chat: chat,
    })
  }
}
